import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: JSON.parse(localStorage.getItem('user') || '[]'),
    userInfo: '',
    orgData: []
  },
  getters: {
  },
  mutations: {
    loginSuccess (state, newData) {
      // debugger
      state.user = newData
      state.userInfo = state.user.token
      localStorage.setItem('user', JSON.stringify(state.user))
      localStorage.setItem('userInfo', JSON.stringify(state.userInfo))
    },
    loginOrgData (state, newData) {
      debugger
      state.orgData = newData
      localStorage.setItem('orgData', JSON.stringify(state.orgData))
    }
  },
  actions: {
  },
  modules: {
  }
})
